import {
  handoff_cards,
  handoff_tabs,
  handover_metrics,
  handover_rows,
  inbound_items,
  outbound_items,
  handoff_rows,
  document_rows,
  obligation_rows,
  renewal_rows,
  bridge_modules,
  drawer_catalog
} from './onboarding_handoff_data.js';

export default {
  name: 'ComplyonOnboardingHandoff',
  data: () => ({
    handoff_tabs,
    handover_metrics,
    handover_rows,
    handoff_cards,
    inbound_items,
    outbound_items,
    handoff_rows,
    drawer_catalog,
    active_drawer_key: null,
    document_rows,
    obligation_rows,
    renewal_rows,
    bridge_modules,
    active_tab: 'handovers'
  }),
  computed: {
    active_drawer() {
      return this.drawer_catalog[this.active_drawer_key] || null;
    }
  },
  methods: {
    set_tab(tab_id) {
      this.active_tab = tab_id;
      this.close_drawer();
    },
    open_drawer(drawer_key) {
      if (!drawer_key) {
        return;
      }
      this.active_drawer_key = drawer_key;
      document.body.classList.add('onboarding-handoff-drawer-open');
      this.$nextTick(() => {
        const drawer_body = this.$refs.drawerBody;
        if (drawer_body) {
          drawer_body.scrollTop = 0;
        }
      });
    },
    close_drawer() {
      this.active_drawer_key = null;
      document.body.classList.remove('onboarding-handoff-drawer-open');
    },
    go_to_handoff_route(route_name) {
      if (!route_name) {
        return;
      }
      this.$router.push({ name: route_name });
    }
  },
  beforeDestroy() {
    this.close_drawer();
  }
};
